// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
 //   $w("#basicText").show("fly", flyOptions);
});


let flyOptions = {
  "duration":   1000,
  "delay":      500,
  "direction":  "bottom"
};

let floatOptions = {
  "duration":   1000,
  "delay":      500,
  "direction":  "bottom"
};


